import React, { useEffect, useState } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";

export default function ScalingOverview(props) {
  const { campaign } = props;

  const useStyles = makeStyles(() => ({
    box: {
      textAlign: "center",
      height: "100%",
      padding: "10px 0",
    },
  }));
  const classes = useStyles();

  const [pending, setPending] = useState(0);
  const [complete, setComplete] = useState(0);

  useEffect(() => {
    // Function: Count and Set Action Status
    if (campaign) {
      let pending = 0;
      let complete = 0;

      campaign.actions.forEach((action) => {
        if (action.status === "PENDING") {
          pending += 1;
        } else if (action.status === "COMPLETE") {
          complete += 1;
        }
      });

      setPending(pending);
      setComplete(complete);
    }
  }, [JSON.stringify(campaign)]);

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item xs={6} className={classes.box}>
        <Typography variant="overline" color="textSecondary">
          <strong> PENDING </strong>{" "}
        </Typography>{" "}
        <Typography variant="h5"> {pending} </Typography>{" "}
      </Grid>
      <Grid item xs={6} className={classes.box}>
        <Typography variant="overline" color="textSecondary">
          <strong> COMPLETE </strong>{" "}
        </Typography>{" "}
        <Typography variant="h5"> {complete} </Typography>{" "}
      </Grid>{" "}
    </Grid>
  );
}
